import { AsyncSelect, OptionProps, components } from '@any-ui-react/select';

import { ValueEditorProps, useValueEditor } from '../../condition-builder';

const ItemPurchasedSelectOption = <Option,>({ children, ...props }: OptionProps<Option>) => {
  return (
    <div title={typeof children === 'string' ? children : undefined}>
      <components.Option {...props}>{children}</components.Option>
    </div>
  );
};

export const ItemPurchasedValueEditor = (props: ValueEditorProps) => {
  const { baseProps, getErrorMessage } = useValueEditor(props);

  const value = props.values?.[0];
  const error = getErrorMessage();

  return (
    <AsyncSelect<{ label: string; value: string }>
      {...baseProps}
      menuPortalTarget={document.body}
      classNames={{
        menu: () => 'min-w-76',
      }}
      components={{
        Option: ItemPurchasedSelectOption,
      }}
      loadOptions={props.field?.onLoadOptions?.(value)}
      defaultOptions
      value={value}
      onChange={(option) => props.onChange?.([option?.value || ''])}
      error={error}
      wrapper={{ className: baseProps.className }}
      disabled={props.disabled}
    />
  );
};
